import {
  FETCH_ACTION_CATALOG,
  FETCH_ACTION_CATALOG_SUCCESS,
  ACTION_CATALOG_ERROR,
  CLEAR_ACTION_CATALOG_ERROR
} from '../../actions/trm/actionCatalog';

const initialState = {
  rows: [],
  loading: false,
  error: null
};

export default function actionCatalog(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_ACTION_CATALOG:
      return { ...state, loading: true, error: null };
    case FETCH_ACTION_CATALOG_SUCCESS:
      return {
        ...state,
        rows: Array.isArray(action.payload) ? action.payload : [],
        loading: false,
        error: null
      };
    case ACTION_CATALOG_ERROR:
      return { ...state, loading: false, error: action.payload };
    case CLEAR_ACTION_CATALOG_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
}
